module.exports = __webpack_public_path__ + "static/grafika3-f203f2c11b449bc24a16a82545380078.png";